module.exports = __webpack_public_path__ + "statics/img/wph_A.png";